import ModeloFormularioService from 'src/modules/modeloFormulario/modeloFormularioService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'MODELOFORMULARIO_VIEW';

const modeloFormularioViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: modeloFormularioViewActions.FIND_STARTED,
      });

      const record = await ModeloFormularioService.find(id);

      dispatch({
        type: modeloFormularioViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: modeloFormularioViewActions.FIND_ERROR,
      });

      getHistory().push('/modelo-formulario');
    }
  },
};

export default modeloFormularioViewActions;
